/**
 * 모구 점주 콘솔 v2 — PDF v3 명세 기반 토큰.
 *
 * Square 계열의 매장 운영 밀도, Toss/PortOne의 결제 상태 명확성,
 * 부드러운 SaaS 감성을 섞은 콘솔 전용 스타일이다.
 * 기존 관리자(frontend/src/styles/uiTokens.js)와 의도적으로 분리한다.
 */

export const colors = {
  brand: {
    primary: '#2563EB',
    primaryHover: '#1D4ED8',
    primarySoft: '#EDF2FD',
    primarySoftBorder: '#C9D9F8',
  },
  canvas: {
    default: '#F6F5F2',
    subtle: '#FFFFFF',
    inset: '#ECEBE7',
  },
  background: '#F6F5F2',
  surface: '#FFFFFF',
  text: {
    primary: '#232A34',
    secondary: '#666F7D',
    muted: '#8A94A3',
    inverse: '#FFFFFF',
  },
  border: {
    strong: '#232A34',
    soft: '#ECEBE7',
    muted: '#D9DDE3',
    subtle: '#ECEBE7',
  },
  navy: '#232A34',
  qa: {
    accent: '#E0A63C',
    bg: '#FBF0DC',
    border: '#E8D5AE',
    fg: '#9A5B08',
  },
  status: {
    success: { bg: '#E8F3EB', fg: '#1E7F44', solid: '#1E7F44', border: '#BFDCC9' },
    info: { bg: '#EDF2FD', fg: '#2563EB', solid: '#2563EB', border: '#C9D9F8' },
    warning: { bg: '#FBF0DC', fg: '#9A5B08', solid: '#E0A63C', border: '#E8D5AE' },
    danger: { bg: '#FCEDEA', fg: '#C63C2E', solid: '#C63C2E', border: '#EFC4BD' },
    neutral: { bg: '#FFFFFF', fg: '#666F7D', solid: '#D9DDE3', border: '#ECEBE7' },
  },
};

export const shadows = {
  card: '0 1px 0 rgba(35, 42, 52, 0.04)',
  cardHover: '0 8px 22px rgba(35, 42, 52, 0.08)',
  sidebar: 'none',
  drawer: '-12px 0 32px rgba(35, 42, 52, 0.16)',
  backdrop: 'rgba(35, 42, 52, 0.40)',
};

export const radius = {
  sm: 6,
  md: 12,
  lg: 12,
  button: 12,
  chip: 6,
  pill: 9999,
};

export const layout = {
  sidebarWidth: 224,
  contentMaxWidth: 1180,
  cardPadding: 2.25,
  cardGap: 1.75,
  pagePaddingX: 3.5,
  pagePaddingY: 3.5,
  sectionGap: 2.75,
  controlHeight: 38,
  compactControlHeight: 34,
  headerControlHeight: 36,
  mobileBreakpoint: 760,
};

export const typography = {
  fontFamily:
    '"Pretendard Variable", "Pretendard", "Noto Sans KR", "Apple SD Gothic Neo", sans-serif',
};
